import $ from 'jquery'

/**
 * Handle toggle off canvas events.
 */
function onToggleHoverableCollapse(event) {
  let $body = $('body');
  let sidebarIconOnly = $body.hasClass('sidebar-icon-only');
  let horizontalMenu = $body.hasClass('horizontal-menu');
  let sidebarFixed = $body.hasClass('sidebar-fixed');
  let $menuItem = $(this);
  if ( ! ('ontouchstart' in document.documentElement)) {
    if (sidebarIconOnly || horizontalMenu) {
      if (sidebarFixed) {
        if (event.type === 'mouseenter') {
          $body.removeClass('sidebar-icon-only');
        }
      }
      else {
        if (event.type === 'mouseenter') {
          $menuItem.addClass('hover-open')
        }
        else {
          $menuItem.removeClass('hover-open')
        }
      }
    }
  }
  else {
    if (sidebarIconOnly || horizontalMenu) {
      if (event.type === 'mouseenter') {
        $menuItem.addClass('hover-open')
      }
      else {
        $menuItem.removeClass('hover-open')
      }
    }
  }
}

/**
 * Add an event listener for toggling off canvas events.
 */
function listenToHoverableCollapse() {
  $(document).on('mouseenter mouseleave', onToggleHoverableCollapse)
}

/**
 * Handle horizontal menu toggle for mobile devices.
 */
function onToggleHorizontalMenu() {
  $('.navbar.horizontal-layout').toggleClass('header-toggled')
}

/**
 * Listen to horizontal menu toggle events.
 */
function listenToToggleHorizontalMenu() {
  $('.navbar.horizontal-layout .navbar-menu-wrapper .navbar-toggler').on(
    'click',
    onToggleHorizontalMenu
  )
}

export {
  listenToHoverableCollapse,
  listenToToggleHorizontalMenu,
}
